import { ChangeDetectionStrategy, Component } from '@angular/core';

import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';
import { FormlyModule } from '@ngx-formly/core';
import { InputV3Component } from '@gea/digital-ui-lib';
import { FormFieldsService } from '../app/services/form-fields.service';
import { NgClass } from '@angular/common';

@Component({
  selector: 'formly-geaui-input-v3',
  imports: [ReactiveFormsModule, FormlyModule, InputV3Component, NgClass],
  template: `
    <div class="formly-custom-input">
      <geaui-input-v3
        [label]="props['label'] ?? ''"
        [disabled]="props['disabled'] ?? false"
        [formFieldName]="field.key?.toString() ?? ''"
        [ngClass]="{ 'red-border': props['errorMessage'] }"
        [formlyAttributes]="field"
        [formGroup]="formGroup"
        (focusOut)="updateField()"
        (focusin)="trackValue()"></geaui-input-v3>
      <span class="field-unit" [ngClass]="{ 'unit-disabled': props['disabled'] }">{{ props['displayUnit'] ?? '' }}</span>
    </div>
  `,
  styles: `
    .formly-custom-input {
      position: relative;
    }

    .field-unit {
      position: absolute;
      right: 0.75rem;
      top: 0.813rem;
      color: black;
    }

    .unit-disabled {
      color: lightgray;
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GeaUiInputV3TypeComponent extends FieldType<FieldTypeConfig> {
  initialValue: any;
  constructor(private readonly formlyService: FormFieldsService) {
    super();
  }
  get formGroup(): FormGroup {
    return this.form as FormGroup;
  }

  trackValue(): void {
    if (this.field.key) {
      this.initialValue = this.formGroup.get(this.field.key.toString())?.value;
    }
  }

  updateField(): void {
    if (this.field.key) {
      const rawVal = this.formGroup.get(this.field.key.toString())?.value;
      const typedVal =
        typeof this.initialValue === 'number' && rawVal !== '' && rawVal != null
          ? Number(rawVal)
          : rawVal;
      if (this.initialValue !== typedVal) {
        this.formlyService.trackField({ key: this.field.key.toString(), value: typedVal });
      }
    }
  }
}
